import React, { createContext } from 'react'

interface OrganizatonContextProps {
  refresh?: boolean
  setRefresh?: (refresh: boolean) => any
}

export const OrganizatonContext = createContext<OrganizatonContextProps>({ })

export default OrganizatonContext